import React from "react";
import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { formatMoney, formatMoney2, formatNumber } from "../../lib/api";

const dec = (v, n) => v.toLocaleString("es-ES", { minimumFractionDigits: n, maximumFractionDigits: n });
export const FMT = {
  eur: formatMoney,
  eur2: formatMoney2,
  num: formatNumber,
  pct: (v) => (v == null ? "—" : `${dec(v, 1)} %`),
  dec: (v) => (v == null ? "—" : dec(v, 2)),
  veces: (v) => (v == null ? "—" : `${dec(v, 2)}×`),
  dias: (v) => (v == null ? "—" : `${formatNumber(v)} días`),
};
export const fmtFila = (f, v) => (v == null ? "—" : FMT[f.kind](v));

export function Variacion({ v, unit, inverso, testid }) {
  if (v == null) return <span className="text-slate-300" data-testid={testid}>—</span>;
  const good = Math.abs(v) < 0.05 ? null : inverso ? v < 0 : v > 0;
  const Icon = good == null ? Minus : v > 0 ? ArrowUpRight : ArrowDownRight;
  const color = good == null ? "text-slate-400" : good ? "text-emerald-600" : "text-red-600";
  return (
    <span className={`inline-flex items-center gap-0.5 font-semibold ${color}`} data-testid={testid}>
      <Icon size={12} />
      {unit === "%" && v >= 900 ? `×${Math.round(v / 100 + 1).toLocaleString("es-ES")}`
        : `${v > 0 ? "+" : ""}${v.toLocaleString("es-ES", { maximumFractionDigits: 1 })} ${unit}`}
    </span>
  );
}

export function KpiTile({ f, comp, highlight }) {
  return (
    <div id={`ind-${f.key}`} className={"card p-4 transition-shadow hover:shadow-md scroll-mt-24 " + (highlight ? "ring-2 ring-sky-400" : "")}
         data-testid={`cuadro-kpi-${f.key}`}>
      <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{f.label}</div>
      <div className="font-display text-2xl font-extrabold mt-1" data-testid={`cuadro-kpi-${f.key}-valor`}>{fmtFila(f, f.actual)}</div>
      <div className="mt-2 pt-2 border-t border-slate-100 space-y-0.5 text-[11px]">
        <div className="flex justify-between gap-2">
          <span className="text-slate-400">vs {comp.anterior || "mes anterior"}</span>
          <Variacion v={f.var_anterior} unit={f.unit} inverso={f.inverso} testid={`cuadro-kpi-${f.key}-var-mes`} />
        </div>
        {comp.anio_anterior && (
          <div className="flex justify-between gap-2">
            <span className="text-slate-400">vs {comp.anio_anterior}</span>
            <Variacion v={f.var_anio} unit={f.unit} inverso={f.inverso} testid={`cuadro-kpi-${f.key}-var-anio`} />
          </div>
        )}
        <div className="flex justify-between gap-2">
          <span className="text-slate-400">media 12 m (meses completos)</span>
          <span className="font-mono text-slate-600">{fmtFila(f, f.media_12m)}</span>
        </div>
      </div>
    </div>
  );
}

export function ParcialAviso({ comp }) {
  if (!comp?.parcial) return null;
  return (
    <div className="card p-4 mb-6 border-amber-300 bg-amber-50 text-sm text-amber-900" data-testid="periodo-parcial-aviso">
      <b>Periodo parcial ({comp.parcial.texto}).</b> Para comparar de forma justa usamos los mismos días
      {comp.anterior ? ` de ${comp.anterior.replace(/ \(.*\)$/, "")}` : " del mes anterior"}
      {comp.anio_anterior ? ` y de ${comp.anio_anterior.replace(/ \(.*\)$/, "")}` : ""}.
      {!comp.anterior && !comp.anio_anterior && " Aún no hay meses anteriores subidos para comparar."}
    </div>
  );
}
